import Customers from "../components/Accounts";
import Header from '../components/header'
import Sidebar from '../components/sidebar'
import { Building2, Users, Landmark } from "lucide-react";

const AccountsPage = () => {
    return (
        <>
        <Header
            title="Customers"
            icon={<Landmark className="w-5 h-5" />}
        />
        <Sidebar />
        <Customers />
        </>
    );
}
export default AccountsPage;